/**
 * 编译 i18n 文案，传入对应参数，这里支持两种参数传入方式
 * 1. 以参数列表的方式进行排序，在字符串中以参数索引方式进行引用
 * ```ts
 * // i18nConfig.zhCN.preview = "试看 $0 秒，前往 $1 观看完整版"
 * compile(i18nConfig.zhCN.preview, '10', '腾讯视频');
 * // => "试看 10 秒，前往腾讯视频观看完整版"
 * ```
 * 2. 以 Record<string, unknown> 的方式进行传入，编译字符串使用设置的对应 keyName 引用
 * ```ts
 * // i18nConfig.zhCN.preview = "试看 $time 秒，前往 $qq_web 观看完整版"
 * compile(i18nConfig.zhCN.preview, { time: 10, qq_web: '腾讯视频' });
 * ```
 * 此外，还支持将 i18n 文案字符串定义为回调函数，参数列表为回调函数中的调用参数
 * // i18nConfig.zhCN.preview = (time, dest) => `试看 ${time} 秒,前往 ${dest} 观看完整版`
 */
function compile(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof message === 'function') {
        return message.apply(void 0, args);
    }
    var result = message;
    for (var i = 0; i < args.length; i++) {
        result = result.replace("$".concat(i), String(args[i]));
    }
    return result;
}
export { compile, compile as t };
export default { compile: compile };
